import * as t from "io-ts";
import { withFallback } from "io-ts-types";
import { Validation } from "io-ts";
import UserAuthService from "../services/UserAuthService";
import ApiService from "../services/ApiService";
import pkg from "../../package.json";

export const EnvironmentIO = t.union([t.literal("local"), t.literal("dev"), t.literal("staging"), t.literal("prod")]);

const defaultAppVersion = pkg.version ?? "0.0.0";
const defaultBuildEnvironment = import.meta.env.MODE ?? "unknown";

// Frontend Config Codecs
export const FrontendConfigIO = t.exact(
    t.type({
        apiUrl: t.string,
        authUrl: t.string,
        webAppUrl: t.string,
        environment: EnvironmentIO,
        maxFileSizePdfTemplateUploadBytes: withFallback(t.number, 10000000),
        appVersion: withFallback(t.string, defaultAppVersion),
        buildEnvironment: withFallback(t.string, defaultBuildEnvironment),
    }),
);

export type Environment = t.TypeOf<typeof EnvironmentIO>;
export type FrontendConfig = t.TypeOf<typeof FrontendConfigIO>;

export interface Dependencies {
    config: FrontendConfig;
    authService: UserAuthService;
    apiService: ApiService;
}

/**
 * Initialize and validate frontend configuration
 * @param rawConfig Raw config object from /config.json or other source
 * @returns Validation result containing either decoding errors or validated config
 */
export function initConfig(rawConfig?: unknown): Validation<FrontendConfig> {
    return FrontendConfigIO.decode(rawConfig || {});
}
